<template>
    <div class="mx-auto col-lg-5 col-md-8 col-sm-10 header-margin">
        <div v-if="errors_token.timeOverToken">
            <!-- トークンデータ24時間超過 -->
            <div class="text-center p-2">
                <h3>{{ $t('auth.changePassword.timeOverTokenTitle') }}</h3>
            </div>
            <div class="show-check-email-message" v-html="$t('auth.timeOverTokenText')"></div><br />
            <div class="text-center">
                <div class="pb-4 ">
                    <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                </div>
            </div>
        </div>
        <div v-if="errors_token.notLatestToken">
            <!-- 対象のトークンが最新のトークンではない -->
            <div class="text-center p-2">
                <h3>{{ $t('auth.changePassword.timeOverTokenTitle') }}</h3>
            </div>
            <div class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div><br />
            <div class="text-center">
                <div class="pb-4 ">
                    <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                </div>
            </div>
        </div>
        <div v-if="errors_token.notExistToken">
            <!-- トークンデータが存在しない -->
            <div class="text-center p-2">
                <h3>{{ $t('auth.changePassword.timeOverTokenTitle') }}</h3>
            </div>
            <div class="text-center p-2">
                {{ $t('auth.notExistTokenText') }}
            </div><br />
            <div class="text-center">
                <div class="pb-4 ">
                    <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                </div>
            </div>
        </div>
        <div v-if="errors_token.success">
            <!-- 正常処理・バリデーションチェック -->
            <div class="text-center p-2">
                <h3>{{ $t('account.password.newpassword') }}</h3>
            </div>
            
            <div class="password-requirement">
                <p>{{ $t('account.password.requirement') }}</p>
                <ul>
                    <li>{{ $t('account.password.rule1') }}</li>
                    <li>{{ $t('account.password.rule2') }}</li>
                    <li>{{ $t('account.password.rule3') }}</li>
                    <li>{{ $t('account.password.rule4') }}</li>
                </ul>
            </div>

            <form @submit.prevent="handleOnSubmit">
                <div class="form-group row">
                    <label for="new_password" class="col-sm-4 col-form-label">{{ $t('account.edit.password') }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.new_password" type="password" id="new_password" name="new_password"
                            class="form-control"
                            v-bind:class="{ 'is-invalid': errors.new_password}"/>
                        <div v-if="errors.new_password" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.new_password) }}</div>
                    </div>
                </div>
                <div v-if="(!errors.new_password)" class="invalid-errors-hiddens"></div>

                <div class="form-group row">
                    <label for="new_password_confirmation" class="col-sm-4 col-form-label">{{ $t('account.edit.passwordAgain')
                        }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.new_password_confirmation" type="password" id="new_password_confirmation"
                            name="new_password_confirmation"
                            class="form-control"
                            v-bind:class="{ 'is-invalid': errors.new_password_confirmation}"/>
                        <div v-if="errors.new_password_confirmation" class="invalid-feedback invalid-errors" >{{ $t('errors.' + errors.new_password_confirmation) }}</div>
                    </div>
                    <div v-if="(!errors.new_password_confirmation)" class="invalid-errors-hiddens"></div>
                </div>
                <div v-if="(!errors.new_password_confirmation)" class="invalid-errors-hiddens-area"></div>
                <div class="text-center btn-position">
                    <div class="pb-4 ">
                        <button type="submit" :disabled="submitBtnDisabled()" class="btn btn-primary">{{ $t('account.edit.submit') }}</button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import UserService from '../../services/UserService';

    export default {
        name: 'change-password',

        components: {

        },

        data() {
            return {
                errors: this.getDefaultFields(),
                errors_token: this.getDefaultFields(),
                formData: this.getDefaultFields(),

                token: null,
                submitted: false,
            }
        },

        created() {
            this.token = this.$route.query.token;
            this.fetchUserData(this.token);
        },

        methods: {
            getDefaultFields() {
                return {
                    new_password: '',
                    new_password_confirmation: '',
                    success: '', 
                    timeOverToken: '',
                    notLatestToken: '',
                    notExistToken: '',
                };
            },

            submitBtnDisabled() {
                return this.submitted;
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    await UserService.authChangePassword({
                        token: this.token,
                        ...this.formData
                    });
                    this.$router.push('/forgot-password/complete');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                if (errItem.field == 'notExistToken' || errItem.field == 'timeOverToken' || errItem.field == 'notLatestToken') {
                                    this.$router.push('/forgot-password/error?title=changePassword&' + 'message=' + errItem.field);
                                } else {
                                    this.errors[errItem.field] = errItem.message[0];
                                }
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                }
            },
            async fetchUserData(token) {
                this.errors_token = this.getDefaultFields();

                try {
                    await UserService.checkForgotPasswordTokenExpiration(token);
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors_token[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .password-requirement {
        margin: 40px 0px 40px 0px; 
    }
    .password-requirement p {
        margin-bottom: 1em;
    }
    .password-requirement ul {
        list-style: disc;
    }
    .password-requirement ul li {
        margin-left: 3.5em;
    }
    .form-group {
        margin-bottom: 0px;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 479px) { /*ウィンドウ幅が479px以上の場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 36px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors-hiddens-area{
            visibility:hidden;
            height: 30px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:36px;
            height:auto !important;
            height:36px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { /*ウィンドウ幅が最大479pxまでの場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 15px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors-hiddens-area{
            visibility:hidden;
            height: 15px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 5px;
        }
        .col-form-label{
            padding-top: 0px;
        }
        .btn-position{
            padding-top: 10px;
        }
    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
